/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';
import CustomHelmet from 'app/components/commons/CustomHelmet';
import StaticContentInner from 'app/components/static/StaticContentInner';
import Title from 'app/components/commons/Title';

type ErrorMessage = {
  key: string,
  message: string
};

type Props = {
  content?: string,
  description?: string,
  errorMessages?: Array<ErrorMessage>,
  htmlTitle?: string,
  isLoading?: boolean,
  layout?: 'complex' | 'simple',
  onMount: () => void,
  title: string
};

const StyledStaticContentInner = glamorous(StaticContentInner)(
  {
    ' a': {
      color: '#5bc0de'
    },
    ' code': {
      backgroundColor: '#f8f8f8',
      border: '1px solid #ccc',
      padding: '3px',
      color: '#333'
    }
  },
  props =>
    props.layout === 'complex'
      ? {
          ' ol': {
            counterReset: 'section',
            listStyle: 'none',
            fontSize: props.theme.fontSize.large,
            paddingLeft: props.theme.spacing.default,
            '> li': {
              paddingTop: props.theme.spacing.default,
              paddingBottom: props.theme.spacing.default,
              '&::before': {
                content: 'counters(section,".") ". "',
                counterIncrement: 'section',
                fontWeight: 'bold'
              },
              '> ol': {
                fontSize: props.theme.fontSize.default,
                '> li': {
                  paddingBottom: 0
                }
              }
            }
          }
        }
      : {}
);

const StaticContentDiv = glamorous.div(props => ({
  paddingLeft: props.theme.spacing.small,
  paddingRight: props.theme.spacing.small
}));

class StaticContent extends React.Component {
  props: Props;

  static defaultProps = {
    content: '',
    description: undefined,
    errorMessages: [],
    isLoading: false,
    layout: 'simple',
    htmlTitle: undefined
  };

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) {
      onMount();
    }
  }

  render() {
    const { content, description, errorMessages, htmlTitle, isLoading, layout, title } = this.props;

    return (
      <StaticContentDiv>
        <CustomHelmet description={description} htmlTitle={htmlTitle} title={title} />
        <Title noWhiteSpace>{title}</Title>
        <hr />
        <StyledStaticContentInner
          content={content}
          errorMessages={errorMessages}
          isLoading={isLoading}
          layout={layout}
        />
      </StaticContentDiv>
    );
  }
}

export default StaticContent;
